import { Button } from '@material-ui/core';

import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { TransitionScreen } from '../TransitionScreen';

const InviteRequiredPageComponent = () => {
  return (
    <TransitionScreen
      title="Confidence is invite-only"
      description={
        <span>
          Confidence is currently available by invitation only. Contact us to
          learn more about how Confidence can help you experiment like Spotify.
        </span>
      }
      actions={
        <Button
          variant="contained"
          color="primary"
          size="large"
          href="mailto:confidence@spotify.com"
        >
          Contact us
        </Button>
      }
    />
  );
};

export const InviteRequiredPage = withPageImpression(
  InviteRequiredPageComponent,
  { pageId: 'invite-required' },
);
